<template>
  <b-container>
    <b-container fluid class="px-0" v-if="state === 'getInput'">
      <h1>You've got some NiRV!</h1>
      <h3 class="mt-5">Welcome to the Neuroimaging Report Viewer</h3>

      <p class="mt-4 text-left">
        You can load data into NiRV using a few methods
      </p>
      <b-tabs content-class="mt-3">
        <b-tab title="Use local files" active>
          <b-form-group
            label="Choose a directory containing input files generated by the NiRV BIDS-App."
            description="All computation happens on the client side. Your data will not be uploaded to any server."
            class="mt-4 text-left"
          >
            <b-form-file
              v-model="files"
              directory
              multiple
              placeholder="Choose a directory..."
            ></b-form-file>
          </b-form-group>
        </b-tab>
        <b-tab title="Use remote files">
          <b-input-group prepend="URI">
            <b-form-input
              v-model="uri"
              placeholder="s3://nirv-example-data"
              @keyup.enter="navigate"
            />
            <b-input-group-append>
              <b-btn text="Button" variant="primary" @click="navigate"
                >Go</b-btn
              >
            </b-input-group-append>
          </b-input-group>
        </b-tab>
        <b-tab title="Load a demo dataset">
          <b-form-group class="mt-4 text-left">
            <b-form-select v-model="selectedDataset" :options="datasets">
              <template #first>
                <b-form-select-option :value="null" disabled
                  >-- Select a demonstration dataset --</b-form-select-option
                >
              </template>
            </b-form-select>
          </b-form-group>
        </b-tab>
      </b-tabs>

      <b-modal id="files-not-found-modal" v-model="showErrorModal" hide-footer>
        <div class="d-block text-center">
          <h3>Error!</h3>
          <p>
            NiRV was unable to find the required
            <code>nirv_group_report.csv</code> or
            <code>nirv_group_report.json</code> files.
          </p>
        </div>
        <b-button class="mt-3" block @click="hideErrorModal">Close</b-button>
      </b-modal>
    </b-container>

    <TheSpinner v-if="state === 'showSpinner'" />
  </b-container>
</template>

<script>
import { ref, watch } from "@vue/composition-api";
import router from "@/router";
import { useReportStore } from "@/stores/store";
import TheSpinner from "@/components/TheSpinner";

export default {
  name: "HomeView",
  components: {
    TheSpinner,
  },
  setup() {
    const store = useReportStore();

    const state = ref("getInput");
    const files = ref(null);
    const uri = ref(null);
    const datasets = [
      { text: "Healthy Brain Network -- QSIPrep", value: "hbn-qsiprep" },
      { text: "Healthy Brain Network -- pyAFQ", value: "hbn-pyafq" },
      { text: "NKI Rockland -- QSIPrep", value: "nki-qsiprep" },
      { text: "NKI Rockland -- pyAFQ", value: "nki-pyafq" },
    ];
    const selectedDataset = ref(null);
    const showErrorModal = ref(false);
    const hideErrorModal = () => {
      showErrorModal.value = false;
    };

    watch(files, async () => {
      if (files.value) {
        state.value = "showSpinner";

        await store.parseFiles(files.value).catch((error) => {
          if (
            error.message.includes("NiRV") &&
            error.message.includes("file not found")
          ) {
            showErrorModal.value = true;
            state.value = "getInput";
            return;
          }
        });

        router.push({ name: "Report" });
      }
    });

    const navigate = async () => {
      state.value = "showSpinner";

      if (uri.value) {
        console.log(uri.value);
      }
    };

    return {
      datasets,
      files,
      uri,
      hideErrorModal,
      selectedDataset,
      showErrorModal,
      state,
      navigate,
    };
  },
};
</script>

<style scoped>
.logo {
  max-width: 250px;
  width: 100%;
  height: auto;
}

h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
